import React, { useState, useEffect } from "react";
import { Button, RadioButton } from "../../../common/commonIndex";
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import CommonService from '../../../services/API/commonService';

const LastColonoscopy = ({ handleNextEvent, formData, questionData }) => {
    const [lastColonoscopy, setSelectedValue] = useState(formData?.answers || "");
    const [isValid, setIsValid] = useState(false);
    const { state: data } = useAuthenticationContext();
    let isMobile = false;

    useEffect(() => {
        isMobile = window.innerWidth > 768 ? 4 : 3;
        if (formData?.answer) {
            setSelectedValue(formData?.answer);
            setIsValid(true);
        } else {
            setSelectedValue('');
            setIsValid(false);
        }
    });

    

    /* Callback function to handle radio button change */
    const handleRadioChange = (value) => {
        setSelectedValue(value);
        setIsValid(true);
        formData.answer = value;
        formData.fkAnswerIds = value;
    };
    /* Submit */
    const handleSubmit = (e) => {
        // skip then 2 otherwise 1
        let skip = 1;
        // if (questionData?.skippedNestedQuestionID) {
        //     skip = 2;
        // }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getLocalStorageData = () =>{
        const findlocalStorageData =  JSON.parse(localStorage.getItem('listOfAnswer'));
         return findlocalStorageData;
     }
     const setLocalStorageData = (data) =>{
       if(data?.length > 0){
         localStorage.setItem('listOfAnswer', JSON.stringify(data));
       }
     }

    return (
        <>
            <div className="email-form-container">
                <h2 className="title" style={{ marginBottom: window.innerWidth > 576 ? "52px" : "22px" }}>{questionData?.question}</h2>
                <div className={questionData?.listOfAnswers?.length > isMobile ?`scrollbar colonoscopy-scrollbar`: ''}>
                    <div className={questionData?.listOfAnswers?.length > isMobile ?`force-overflow` : ''}>
                        <form className="mt-2">
                            <div className="list radio-button gender  last-colonoscopy-choose mb-md-5">
                                {questionData?.listOfAnswers?.map((item, index) => {
                                    const isSelected = lastColonoscopy === item;
                                    const className = isSelected ? "list-item selection selected" : "list-item selection";
                                    return (
                                        <div className={className} key={index}>
                                            <RadioButton
                                                radioButton="gender"
                                                name={item.answer}
                                                id={index}
                                                onRadioChange={handleRadioChange}
                                                formData={formData}
                                                value={lastColonoscopy}
                                                setValue={setSelectedValue}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={isValid}
                    />
                </div>
            </div>
        </>
    )
};

export default LastColonoscopy;